import { ANNOUNCEMENT } from "../content/site";
import { langFromPath, localePath } from "../i18n/lang";

export function AnnouncementBar() {
  const { lang } = langFromPath(window.location.pathname);
  return (
    <a
      href={localePath(ANNOUNCEMENT.href, lang)}
      className="flex min-h-11 flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-magenta px-5 py-2 text-center text-[0.8rem] font-medium text-white hover:bg-magenta-deep md:px-10"
    >
      <span className="md:line-clamp-1">{ANNOUNCEMENT.text}</span>
      <span className="shrink-0 rounded-full border border-white/70 px-3 py-0.5 text-[0.72rem] font-semibold uppercase tracking-wider">
        {ANNOUNCEMENT.cta}
      </span>
    </a>
  );
}
